export default {
    routerName: '角色管理',
    role: {
        searchName: '检索条件',
        name: '角色名',
        code: '代号',
        authority: '权限',
        createTime: '创建时间',
        createStartTime: '创建开始时间',
        createEndTime: '创建结束时间',
        status: '状态',
        open: '启用',
        close: '停用',
        sortOrder: '排序',
    },
    table: {
        id: 'ID',
        name: '角色名',
        code: '代号',
        sortOrder: '排序',
        createBy: '创建者',
        createTime: '创建时间',
        status: '状态',
    },
};
